import { resolveRemediation } from "../../utils/remediationCatalog.js";
import { distinctRemediationSteps } from "../../utils/remediationDisplay.js";

/**
 * Per-finding remediation guidance from the catalog.
 *
 * @param {{ ruleId?: string, providerId?: string, expectedFallback?: string, variant?: 'dashboard' | 'report' }} props
 */
export default function FindingRemediationBlock({
  ruleId,
  providerId,
  expectedFallback,
  variant = "dashboard",
}) {
  const remediation = resolveRemediation(ruleId, providerId);
  const muted =
    variant === "report" ? "var(--idaxis-print-muted, #334155)" : "var(--text-secondary, #94a3b8)";
  const text =
    variant === "report" ? "var(--idaxis-print-text, #0b1b34)" : "var(--text-primary, #e2e8f0)";
  const accent = variant === "report" ? "#1d4ed8" : "var(--accent, #38bdf8)";

  if (!remediation) {
    if (!expectedFallback) return null;
    return (
      <p style={{ marginTop: 10, marginBottom: 0, fontSize: 13, lineHeight: 1.5, color: muted }}>
        <span style={{ fontStyle: "italic" }}>Expected:</span> {expectedFallback}
      </p>
    );
  }

  const steps = distinctRemediationSteps(remediation.remediation_summary, remediation.remediation_steps);
  const refs = Array.isArray(remediation.references) ? remediation.references : [];

  return (
    <div style={{ marginTop: 10 }}>
      <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.04em", color: muted }}>
        How to fix
      </div>
      <p style={{ margin: "6px 0 0", fontSize: 13, lineHeight: 1.5, color: text }}>
        {remediation.remediation_summary}
      </p>
      {steps.length > 0 || refs.length > 0 ? (
        <details style={{ marginTop: 8 }}>
          <summary style={{ cursor: "pointer", fontSize: 12, color: muted }}>
            Show steps{refs.length > 0 ? " & references" : ""}
          </summary>
          {steps.length > 0 ? (
            <ol style={{ margin: "8px 0 0", paddingLeft: 18, fontSize: 12, lineHeight: 1.5, color: muted }}>
              {steps.map((step, i) => (
                <li key={i} style={{ marginBottom: 4 }}>
                  {step}
                </li>
              ))}
            </ol>
          ) : null}
          {refs.length > 0 ? (
            <ul style={{ margin: "8px 0 0", paddingLeft: 18, fontSize: 12, lineHeight: 1.5, listStyle: "none" }}>
              {refs.map((ref, i) => {
                const label = ref?.label || ref?.title || ref?.url || "Reference";
                const href = ref?.url || null;
                return (
                  <li key={i} style={{ marginBottom: 4 }}>
                    {href ? (
                      <a href={href} target="_blank" rel="noreferrer" style={{ color: accent, textDecoration: "none" }}>
                        {label}
                      </a>
                    ) : (
                      <span style={{ color: muted }}>{label}</span>
                    )}
                  </li>
                );
              })}
            </ul>
          ) : null}
        </details>
      ) : null}
    </div>
  );
}
